import React from "react";

import "./Trademark.scss";

export const Trademark: React.FC = () => (
  <div className="infoModalContent infoModalContent--trademark">
    <h2>Trademark</h2>
    <p>
      TR-808, TB-303, Computer Controlled, Rhythm Composer and Bass Line are
      trademarks or registered trademarks of Roland Corporation in the U.S.,
      U.K., European Union, and other countries
    </p>
  </div>
);
